import { alpha, Components, Theme } from "@mui/material";

export const vrToggleButtonGroupOverride: Components<Theme>["MuiToggleButtonGroup"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      "&[data-shape='pill']": {
        padding: theme.spacing(0.5),
        borderRadius: theme.spacing(20),
        backgroundColor: alpha(theme.palette.common.black, 0.6),
        backdropFilter: `blur(${theme.spacing(1)})`,
        "& .MuiToggleButtonGroup-grouped": {
          flex: 1,
          margin: 0,
          padding: theme.spacing(1.5, 3),
          border: 0,
          borderRadius: "inherit",
          color: theme.palette.common.white,
          ...theme.typography.textLg600,
          textTransform: "none",
          whiteSpace: "nowrap",
          transition: "color 0.25s ease, background-color 0.2s ease",
          "&:hover": {
            backgroundColor: alpha(theme.palette.common.white, 0.12),
          },
          "&.Mui-selected": {
            color: theme.palette.common.black,
            backgroundColor: theme.palette.common.white,
            "&:hover": {
              backgroundColor: alpha(theme.palette.common.white, 0.8),
            },
          },
          "&.Mui-focusVisible": {
            outline: `2px solid ${theme.palette.dsPrimary.v300}`,
            outlineOffset: 2,
          },
          "&.Mui-disabled": {
            color: theme.palette.dsNeutral.v400,
          },
          "@media (prefers-reduced-motion: reduce)": {
            transition: "none",
          },
        },
      },
    }),
  },
};
